import { useContext, useEffect, useRef, useState } from "react";

// components

import { FeatureCardsSkeleton } from "components/Loader/HomeSkeletonLoader/FeatureCardsSkeleton";

// helpers
import getImg from "helpers/getCloudinaryImage";
import parseHTML from "helpers/parseHTML";

// context
import { SearchPageDataInterface } from "context/SearchPageData";

// assets
import { SvgHouseSearching as HouseSearching } from "assets/icons/js/SvgHouseSearching";

// styles
import "./style.scss";
import clevertap from "clevertap-web-sdk";
import { SearchWidenFilter } from "components/Search/SearchWeb/SearchWidenFilter";
import { SearchCardsSkeleton } from "components/Loader/SearchCardsSkeleton";

const CardContainer = ({ Card }: any) => {
	// @ts-ignore
	const { searchResults, ref, query } = useContext(SearchPageDataInterface);
	useEffect(() => {
		if (document && searchResults.isSuccess) {
			const villa1 = searchResults?.data?.pages[0]?.data?.data[0];
			const villa2 = searchResults?.data?.pages[0]?.data?.data[1];
			const villa3 = searchResults?.data?.pages[0]?.data?.data[2];

			const villaNames = [villa1, villa2, villa3]
				.map((villa) => villa?.title)
				.filter(Boolean)
				.join(", ");
			const villaImages = [villa1, villa2, villa3]
				.map(
					(villa) =>
						`https://ik.imagekit.io/5tgxhsqev/saffronstays-media/tr:w-800,h-460,q-62/image/upload/${villa?.imagesList[0]}.webp`,
				)
				.filter(Boolean)
				.join(" , ");

			clevertap.event.push("view_search_page_dynamic", {
				villaName: villaNames,
				slug: window.location.search,
				villaImg: villaImages,
			});

			const arrId = searchResults?.data?.pages[0]?.data?.data.map(
				(ele: any) => ele.id,
			);
			const city = searchResults?.data?.pages[0]?.data?.data[0]?.city;
			const state = searchResults?.data?.pages[0]?.data?.data[0]?.state;
			const fbScript = document.createElement("script");
			const SchemaObj = {
				currency: "INR",
				content_ids: arrId,
				region: state,
				city: city,
				country: "India",
				content_type: "hotel",
				checkin_date: query?.get("checkin"),
				checkout_date: query?.get("checkout"),
				num_adults: query?.get("guests"),
			};
			if (!query?.get("checkin")) {
				delete SchemaObj.checkin_date;
			}
			if (!query?.get("checkout")) {
				delete SchemaObj.checkout_date;
			}
			if (!query?.get("guests")) {
				delete SchemaObj.num_adults;
			}
			fbScript.innerHTML = `fbq('track', 'Search', ${JSON.stringify(
				SchemaObj,
			)});`;
			fbScript.defer = true;
			fbScript.async = true;
			document.head.appendChild(fbScript);
		}
	}, [searchResults.isSuccess]);

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	if (searchResults?.status === "loading") {
		const skelArr = new Array(6).fill(0);

		return (
			<main className="card__container__wrapper">
				<div className="card__container">
					{skelArr?.map((item) => (
						<SearchCardsSkeleton key={Math.random() * 100} />
					))}
				</div>
			</main>
		);
	}

	if (searchResults?.status === "error") {
		return (
			<div className="illustration">
				<HouseSearching />
				<h6>Opps, we couldn't find any results</h6>
				<p>Try searching for something else</p>
			</div>
		);
	}

	if (typeof searchResults?.data?.pages[0]?.data?.data === "string") {
		return (
			<div className="illustration">
				<HouseSearching />
				<h6>Opps, we couldn't find any results</h6>
				<p>Try searching for something else</p>
			</div>
		);
	}

	return (
		<main className="card__container__wrapper">
			<div className="card__container">
				{searchResults.isSuccess &&
					searchResults?.data?.pages?.map((page: any, index: number) => {
						if (typeof page.data.data !== "string") {
							return page?.data?.data.map((searchResult: any) => {
								if (
									(searchResult.approval_status !== "L" ||
										searchResult.approval_status !== "P") &&
									searchResult.priceWithoutGst !== 0
								) {
									// @ts-ignore
									const amen = Object.values(searchResult?.amenityList);
									const sui = Object.values(searchResult?.suitableList);
									const benefits = [...amen, ...sui];

									// getting image from data and menuplating it
									const imgArray = Object.values(searchResult.imagesList);
									const imgNewArray = imgArray?.map((v: any) => {
										return getImg({
											id: v.ImgId,
											version: v.version,
											quality: "62",
											width: "800",
											height: "460",
										});
									});
									const img = imgNewArray.splice(0, 5);
									const type =
										searchResult.type_flag === "EV"
											? "Entire Home"
											: searchResult.type_flag === "MV"
											? "Separate Villas"
											: searchResult.type_flag === "SR"
											? "Single Room"
											: searchResult.type_flag === "MR"
											? "Separate Rooms"
											: searchResult.type_flag === "EV-MR"
											? "Entire Home"
											: searchResult.type_flag === "CL"
											? "Group of Villas"
											: "";

									return (
										<Card
											key={searchResult.id}
											// @ts-ignore
											id={searchResult.id}
											title={parseHTML(searchResult.title.split(" - ")[0])}
											location={searchResult.location}
											img={img}
											benefits={benefits}
											rating={searchResult.overallRatings}
											reviews={searchResult.totalReviews}
											discountPrice={searchResult.pricePerNightWithoutgenDis}
											numOfNights={searchResult.numOfnights}
											price={searchResult.pricePerNightWithoutGst}
											signature={searchResult.is_signature}
											newHome={searchResult.new_home === 0 ? false : true}
											noOfBedrooms={searchResult.numSimilarRooms}
											capacity={searchResult.TotalCapacity}
											minCap={searchResult.capacity}
											minRooms={searchResult.minRooms}
											type={type}
											inCollection={searchResult.inDreamList}
											available={searchResult.availability}
											seoURL={searchResult.seoURL}
											hideAvail={false}
											cancellation={
												searchResult.CANCELLATION_POLICY === "FREECANCELLATION"
											}
											prevLocation="Search"
											newHomeDis={
												searchResult.new_home_discount === 0 ? false : true
											}
											NO_OF_BEDROOMS={searchResult.NO_OF_BEDROOMS}
											next={false}
											RED_TAPE={searchResult.RED_TAPE}
											xseries={searchResult.is_xseries}
											UNLOCK_MAGIC={searchResult?.UNLOCK_MAGIC}
											suitableList={searchResult?.suitableList}
											HIGH_TAC={searchResult?.HIGH_TAC}
											is_next = {searchResult?.is_next}
										/>
									);
								}
								return null;
							});
						}
						return null;
					})}
			</div>

			{searchResults.isFetchingNextPage && (
				<div className="card__container" style={{ marginTop: "20px" }}>
					{[1, 2, 3, 4, 5, 6]?.map((item) => (
						<SearchCardsSkeleton key={Math.random() * 100} />
					))}
				</div>
			)}

			{searchResults?.data?.pages?.map((page: any, index: number) => {
				const isLastPage =
					page?.data?.meta?.currentPage === page.data?.meta?.totalPages;
				return (
					<>
						{isLastPage && (
							<main style={{ padding: "0 0" }}>
								<div className="search__radius">
									<SearchWidenFilter query={query} />
								</div>
							</main>
						)}
					</>
				);
			})}

			<span ref={ref}></span>
		</main>
	);
};

export default CardContainer;
